import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const OwnerRegister = createAsyncThunk(
  "owner/registration",
  async (formData, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token");

      const response = await axios.post(
        `${BASE_URL}/owner-registration`,
        formData, // ✅ direct FormData
        {
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            // ❌ Don't set Content-Type
            // axios sets the multipart boundary automatically
          },
        }
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const OwnerRegistration = createSlice({
  name: "ownerRegistration",
  initialState: {
    loading: false,
    ownerData: null,
    error: "",
    success: false,
  },
  reducers: {
    resetOwnerRegistration: (state) => {
      state.loading = false;
      state.ownerData = null;
      state.error = "";
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(OwnerRegister.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.success = false;
      })
      .addCase(OwnerRegister.fulfilled, (state, action) => {
        state.loading = false;
        state.ownerData = action.payload;
        state.success = true;
        state.error = "";
      })
      .addCase(OwnerRegister.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.success = false;
      });
  },
});

export const { resetOwnerRegistration } = OwnerRegistration.actions;
export default OwnerRegistration.reducer;
